export default "/NFTs.5d64ba4d25e8db98d20c4126a08eadd3.png";